import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddAnimalBreedFarmTypeMutation, useDeleteAnimalBreedFarmTypeMutation, useEditAnimalBreedFarmTypeMutation } from "../../../../redux/api/handBooksApi/animalBreadFarmTypeApi";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";



const useAnimalBreedTypes = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addAnimalBreedFarmType] = useAddAnimalBreedFarmTypeMutation();
    const [deleteAnimalBreedFarmType] = useDeleteAnimalBreedFarmTypeMutation();
    const [editAnimalBreedFarmType] = useEditAnimalBreedFarmTypeMutation();


    async function onAddAnimalBreedFarmType(newAnimalFarmBreedType: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await addAnimalBreedFarmType(newAnimalFarmBreedType).then((response: any) => {
                if (response.error !== undefined) {
                    
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteAnimalBreedFarmType(animalBreedFarmType: EntDirectoryInfoName) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteAnimalBreedFarmType(animalBreedFarmType.id as number).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditAnimalBreedFarmType(editedAnimalBreedFarmType: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await editAnimalBreedFarmType(editedAnimalBreedFarmType).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddAnimalBreedFarmType,onDeleteAnimalBreedFarmType, onEditAnimalBreedFarmType }

}
export { useAnimalBreedTypes };

